import { EventEmitter } from "eventemitter3";
import { AlertAnomalyAction } from "./TraceViewAlertStatus.types";

export interface TraceViewAlertAnomalyStatusEmitterType {
    setSelectedAlertAnomalyAction: (action: AlertAnomalyAction) => void;
}

export const TraceViewAlertAnomalyStatusEmitter = new EventEmitter<TraceViewAlertAnomalyStatusEmitterType>();
